import React from "react";
import { useTranslation } from "react-i18next";
import {
  TrendingDown,
  Clock3,
  BarChart3,
  FileText,
} from "lucide-react";

const Painpoints = () => {
  const { t } = useTranslation();

  const painPoints = [
    {
      icon: <TrendingDown size={22} />,
      title: t("Stock-outs & theft drain profit"),
      desc: t("You only realise an item is sold out when a customer asks. By then, you've already lost the sale and probably blamed staff."),
      fix: t("Real-time stock alerts & staff audit log"),
    },
    {
      icon: <Clock3 size={22} />,
      title: t("Slow billing kills queues"),
      desc: t("Manual price calculation + handwritten receipts = long waits + walk-aways. Every minute lost is a customer lost."),
      fix: t("Barcode scan + auto receipt in 2 seconds"),
    },
    {
      icon: <BarChart3 size={22} />,
      title: t("No clue what's actually selling"),
      desc: t("Without a dashboard, you can't tell which products move, which staff perform, or where margin leaks."),
      fix: t("Live sales reports by item, branch & staff"),
    },
    {
      icon: <FileText size={22} />,
      title: t("Tax authority paperwork is scary"),
      desc: t("Egypt's e-invoice / e-receipt rules keep changing. Manual compliance risks fines and shutdowns."),
      fix: t("ETA-compliant e-invoice & e-receipt built in"),
    },
  ];

  return (
    <section className="py-24">
      <div className="mx-auto px-5" style={{ maxWidth: "1180px" }}>

        {/* Section Head */}
        <div className="mx-auto mb-14 max-w-[700px] text-center">

          <h2 className="mb-3 text-[clamp(28px,3.6vw,44px)] font-black leading-[1.12] tracking-[-1.2px] text-gray-900">
            {t("Tired of losing money to messy spreadsheets and slow billing?")}
          </h2>
          <p className="text-[17px] leading-relaxed text-gray-500">
            {t("Most Egyptian shops still rely on paper logs or expensive legacy POS that takes weeks to install. Hisabak fixes the four biggest pains fast.")}
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-5 md:grid-cols-2">
          {painPoints.map((item, index) => (
            <article
              key={index}
              className="flex items-start gap-[18px] rounded-[20px] border-[1.5px] border-gray-200 bg-white p-7 transition-all duration-300 hover:-translate-y-[3px] hover:border-[#1B4597] hover:shadow-[0_4px_24px_rgba(27,69,151,0.10)]"
            >
              {/* Icon */}
              <div
                className="grid h-[50px] w-[50px] flex-shrink-0 place-items-center rounded-[13px] text-red-600"
                style={{ background: "linear-gradient(135deg, #fef2f2, #fee2e2)" }}
              >
                {item.icon}
              </div>

              {/* Content */}
              <div>
                <h3 className="mb-[7px] text-[16.5px] font-extrabold tracking-[-0.2px] text-gray-900">
                  {item.title}
                </h3>
                <p className="text-[14px] leading-[1.65] text-gray-500">
                  {item.desc}
                </p>
                <div className="mt-[11px] flex items-center gap-[5px] text-[13px] font-bold text-green-600">
                  → {item.fix}
                </div>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Painpoints;